<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <input type="text" autofocus ref="shelf" class="form-control" placeholder="input the shelf code" aria-label="SHELF" aria-describedby="button-addon2" v-model="scaned" v-on:keyup.13="getInfo($event)">
          <div class="input-group-append">
            <button class="btn btn-secondary" type="button" id="button-addon2" v-on:click="getInfo($event)">Get code</button>
          </div>
        </div>
      </div>
    </div>
    <ProductsListShelf @setFocus="setFocus()"/>
  </div>
</template>

<script>
  import ProductsListShelf from '@/components/ProductsListShelf'
  import { mapMutations, mapActions } from 'vuex'

  export default {
    name: 'SearchFormShelf',

    components: {
      ProductsListShelf
    },

    data () {
      return {
        scaned: ''
      }
    },

    mounted () {
      // console.log(this)
      this.setFocus()
    },

    methods: {
      ...mapMutations(['updateScaned']),
      ...mapActions(['getProductsListByShelf']),
      getInfo ($e) {
        this.updateScaned({scaned: this.scaned})
        this.getProductsListByShelf()
        this.setFocus()
      },
      setFocus () {
        this.scaned = ''
        this.$refs.shelf.focus()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SearchFormShelf.vue